// Images
export const ACROSS_LOGO = require("../assets/images/AcrossLogo.png");
export const APB_ILLUSTRATION = require("../assets/images/APBLoginIllustration.png");
export const AUTH_GRAPHICS = require("../assets/images/Graphics.jpg");
